export default __webpack_public_path__ + "static/media/fuljens_henry.7e9b6348.png";